import { DeepPartial } from '@apollo/client/utilities'
import { TimeoffLeaveApprovableMetadataFragment } from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

import { getTimeoffDefaultsLabel } from './helpers'

export const getTimeoffLeaveMetadata = (
  data: DeepPartial<TimeoffLeaveApprovableMetadataFragment>
) => {
  const res: string[] = []

  const type =
    data.leaveType?.identifier === 'custom'
      ? data.leaveType?.name ?? ''
      : getTimeoffDefaultsLabel(data.leaveType?.identifier ?? 'generic')

  if (type) {
    res.push(type)
  }

  const startOn = data.startOn ? stringToDate(data.startOn, 'backend_datetime') : undefined
  const endOn = data.finishOn ? stringToDate(data.finishOn, 'backend_datetime') : undefined

  const displayStartOn = startOn ? i18nDateToString(startOn, 'ui_dmy_long') : ''
  const displayEndOn = endOn ? i18nDateToString(endOn, 'ui_dmy_long') : ''

  const period = displayStartOn
    ? displayEndOn && displayEndOn !== displayStartOn
      ? `${displayStartOn} - ${displayEndOn}`
      : displayStartOn
    : ''

  if (period) {
    res.push(period)
  }

  return res
}
